import httpService from "./http.service";

class MainPageService {
  getMainPageUrl = "/main-page";

  getMainPage = () => {
    return httpService.get(this.getMainPageUrl);
  };
  getMainPageAdmin = () => {
    return httpService.get(this.getMainPageUrl + "/admin");
  };
  createMainPage = (model) => {
    return httpService.form("/main-page", model, "createMainPage");
  };
  editMainPage = (id, model) => {
    return httpService.form("/main-page/" + id, model, "editMainPage", {}, "patch");
  };
  udpateSortMainPage = (type, model) => {
    return httpService.patch("/main-page/update-sort/" + type, model);
  };
  deleteMainPage = (id) => {
    return httpService.delete("/main-page/" + id);
  };
  createContent = (rowId, model) => httpService.form(`/main-page/content/${rowId}`, model, "createMainPageContent");
  editContent = (rowId, index, model) => httpService.form(`/main-page/content/${rowId}/${index}`, model, "updateMainPageContent", {}, "patch");
  deleteContent = (rowId, index) => httpService.delete(`/main-page/content/${rowId}/${index}`);
  createComment = (rowId, model) => httpService.post(`/main-page/content/${rowId}`, model);
  editComment = (rowId, index, model) => httpService.patch(`/main-page/content/${rowId}/${index}`, model);
  selectGlasses = (rowId, ids) => httpService.post(`/main-page/content/glasses/${rowId}`, ids);
  selectBrands = (rowId, ids) => httpService.post(`/main-page/content/brands/${rowId}`, ids);
}

const mainPageService = new MainPageService();
export default mainPageService;
